// ─── KPI 카드 ─────────────────────────────────────────────────────────────────
import React from 'react';

/**
 * 단일 KPI 지표를 아이콘·수치·라벨·서브텍스트·배지와 함께 카드 형태로 표시합니다.
 * @param {{ icon: React.ElementType, iconBg: string, iconColor: string,
 *           value: string|number, label: string, sub?: string, badge?: React.ReactNode }} props
 */
export default function KpiCard({ icon: Icon, iconBg, iconColor, value, label, sub, badge }) {
  return (
    <div className="flex flex-col rounded-xl border border-gray-100 bg-white p-5 shadow-sm">
      <div className={`mb-3 flex h-1 w-1 shrink-0 items-center justify-center rounded-lg ${iconBg}`}>
        <Icon size={18} className={iconColor} />
      </div>
      <p className="font-mono text-5xl font-bold leading-none text-sb-header">{value}</p>
      <p className="mt-2 text-xl font-medium text-gray-600">{label}</p>
      {sub   && <p className="mt-1 font-mono text-base text-gray-400">{sub}</p>}
      {badge && <div className="mt-2">{badge}</div>}
    </div>
  );
}
